import { api } from "@/lib/api";

export const IMPORT_ACCEPT = ".csv,.txt,.html,.htm,.xlsx,.xlsm,.xls,text/csv,text/plain,text/html,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const readAs = (file, method) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r[method](file); });

// Returns CSV text for any supported upload (CSV passthrough; HTML/Excel converted server-side).
export async function fileToCsv(file) {
  const name = file.name.toLowerCase();
  if (/\.(xlsx|xlsm|xls)$/.test(name)) {
    const b64 = String(await readAs(file, "readAsDataURL")).split(",")[1];
    const { data } = await api.post("/import/convert", { file_b64: b64, file_name: file.name });
    return data.csv_text;
  }
  const text = String((await readAs(file, "readAsText")) || "");
  if (/\.(html?|xml)$/.test(name) || /^\s*</.test(text)) {
    const { data } = await api.post("/import/convert", { csv_text: text, file_name: file.name });
    return data.csv_text;
  }
  return text;
}
